export const INITIAL_DATA_LOADED = 'INITIAL_DATA_LOADED';
export const NEWS_TARGET_MODAL_OPENED = 'NEWS_TARGET_MODAL_OPENED';
export const NEWS_TARGET_MODAL_CLOSED = ' NEWS_TARGET_MODAL_CLOSED';
export const NEWS_TARGET_ADDED = ' NEWS_TARGET_ADDED';
export const NEWS_TARGET_REMOVED = 'NEWS_TARGET_REMOVED';
export const NEWS_TARGET_CLEAR = 'NEWS_TARGET_CLEAR';

export const loadInitialDatas = () => (dispatch, getState) => {
  const datas = __INITIAL_DATA__;

  dispatch({
    type: INITIAL_DATA_LOADED,
    payload: {
      datas,
    },
  });
};

export const openModal = () => (dispatch, getState) => {
  dispatch({
    type: NEWS_TARGET_MODAL_OPENED,
  });
};

export const closeModal = () => (dispatch, getState) => {
  dispatch({
    type: NEWS_TARGET_MODAL_CLOSED,
  });
};

export const addTarget = target => (dispatch, getState) => {
  dispatch({
    type: NEWS_TARGET_ADDED,
    payload: {
      target,
    },
  });
};

export const removeTarget = pos => (dispatch, getState) => {
  dispatch({
    type: NEWS_TARGET_REMOVED,
    payload: {
      pos,
    },
  });
};

export const clearTarget = () => (dispatch, getState) => {
  dispatch({
    type: NEWS_TARGET_CLEAR,
  });
};



// WEBPACK FOOTER //
// ./src/modules/news/actions/index.js